(function ($) {

	$(function () {

		/**
		 *  PROJECTS FILTER FUNCTIONING
		 **/

		function fillUpResults(res, cb) {
			$(".news-lister").removeClass("loading");
			$(".news-lister").html(res.data.return_news);
			$(".news-count").text(res.data.count);
			cb();
		}

		var getUrlParameter = function getUrlParameter(sParam) {
			var sPageURL = decodeURIComponent(window.location.search.substring(1)),
				sURLVariables = sPageURL.split('&'),
				sParameterName,
				i;

			for (i = 0; i < sURLVariables.length; i++) {
				sParameterName = sURLVariables[i].split('=');

				if (sParameterName[0] === sParam) {
					return sParameterName[1] === undefined ? true : sParameterName[1];
				}
			}
		};

		//year from url
		var search_year = getUrlParameter('y');
		if(!search_year){
			search_year = 'all';
		}

		if($('input[name="search-year"]').length){
			$("input#" + search_year)[0].checked = true;
		}
		

		//tag from url
		var search_news = getUrlParameter('t');
		if(!search_news){
			search_news = 'all';
		}

		$("select[name='news-tag']").val(search_news);
		$("select[name='news-tag']").selectric('refresh');

		//if there has been a change event on one of the project filter inputs
		$(".news-filter-screen select, input[name='search-year']").on("change", function () {

			var data = {
				action: 'ajax_filternews',
				nonce: filternews_ajax.nonce,
				search_year: $("input[name='search-year']:checked").val(),
				news_tag: $("select[name='news-tag']").val(),
				isarchive: $("input[name='isarchive']").data('isarchive')
			};

			var hash = '?y='+$("input[name='search-year']:checked").val() + '&t='+$("select[name='news-tag']").val();
			//console.log($("input[name='search-year']:checked").val());
			window.history.replaceState(null, null, hash);

			$.ajax({
				type: 'POST',
				url: filternews_ajax.url,
				data: data,
				success: function (res) {
					fillUpResults(res, function () {
						//get the results and reinit the scroller based on the new elements
						initScroller();
					});
					bLazy = new Blazy();
				},
				//before we send our ajax request, show a spinner to the user and also reduce the opacity on previous project results
				beforeSend: function () {
					$(".news-lister").addClass("loading");
					$('.news-lister').append('<div id="loader" class="text-xs-center"><i class="fa fa-circle-o-notch fa-spin" style="font-size:24px; color: #03334f;"></i></div>');
				}
			});
		});

		//when filter values come from url
		$("select[name='news-tag']").change();

		var news_cnt = $(".post-listing .half-height").length;
		$(".news-filter-screen .news-count").text(news_cnt);

		$(".news-filter-screen select").selectric({
			inheritOriginalWidth: true
		});

	});

})(jQuery);